import { FieldTypes } from '../../../constants'
import { addCondition } from '../../../fields/utils'
import { CheckboxField, FieldMap, FormElement } from '../../../types'
import { FieldEncounterSection } from '../types/encounter'

export const pelvicExamField: FieldMap = {
  name: 'Pelvic Exam',
  children: {
    vulva: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Vulva',
      optional: true,
    },
    vaginalPink: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Vaginal Pink',
      optional: true,
    },
    cervix: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Cervix',
      optional: true,
    },
    uterus: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Uterus',
      optional: true,
    },
    adnexa: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Adnexa',
      optional: true,
    },
    rectum: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Rectum',
      optional: true,
    },
    pelvis: {
      type: FieldTypes.EXAM_SECTION,
      placeholder: 'Pelvis',
      optional: true,
    },
  },
}

export const hasPelvicExamField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Pelvic Exam',
  size: 'lg',
}

export const getPelvicExamSection: (optional: boolean) => FieldEncounterSection = optional => {
  const children: Record<string, FormElement> = {}
  if (optional) {
    children.hasPelvicExam = hasPelvicExamField
    children.pelvic = addCondition(pelvicExamField, v => !!v?.hasPelvicExam)
  } else {
    children.pelvic = pelvicExamField
  }
  return {
    type: 'field',
    field: {
      name: 'Pelvic Exam',
      children,
    },
  }
}
